import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import {
  ModalItem,
} from "../../../../../Components/Items";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import matrizPdf from "../../../../../Pdf/matrizPdf";
pdfMake.vfs = pdfFonts.pdfMake.vfs;

class VistaPreviaMat extends Component {
  state = {
    loading: false,
    pdf: null,
  };
  componentDidUpdate(prevProps) {
    if (this.props.visible !== prevProps.visible && this.props.visible)
      this.consultarTodo();
  }
  async consultarTodo() {
    this.setState({ loading: true });
    await axios
      .post(
        "matrices/datosPdf",
        { matrizId: this.props.id, empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        const pdf = pdfMake.createPdf(matrizPdf(res.data));
        this.setState(
          {
            loading: false,
            pdf: pdf,
          },
          () => {
            pdf.open({}, window.frames["matrizPdf"]);
          }
        );
      })
      .catch((err) => {
        console.error(err);
        this.setState({ loading: false });
      });
  }

  cerrarModalPdf() {
    this.props.cerrarModalPdf();
  }

  render() {
    return (
        <ModalItem
        title="Vista previa"
        visible={this.props.visible}
        spinning={this.state.loading}
        onCancel={this.cerrarModalPdf.bind(this)}
        paddingTop
      >
        <iframe
          title={"Matrices"}
          style={{ width: "100%", height: "100vh" }}
          id="matrizPdf"
          name="matrizPdf"
        />
      </ModalItem>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
  };
};

export default connect(mapStateToProps)(VistaPreviaMat);
